if (!customElements.get('main-collection-2-filter-drawer-toggle')) {
  class MainCollection2FilterDrawerToggle extends HTMLElement {
    constructor() {
      super();

      this.drawer = null;
      this.panel = null;
      this.overlay = null;

      this.onClickHandler = this.onClickHandler.bind(this);
      this.openDrawer = this.openDrawer.bind(this);
      this.onOverlayClickHandler = this.onOverlayClickHandler.bind(this);
      this.onDocumentKeydownHandler = this.onDocumentKeydownHandler.bind(this);
    }

    connectedCallback() {
      const targetId = this.getAttribute('target') || 'MainCollection2FilterDrawer';

      this.drawer = document.getElementById(targetId);

      if (!this.drawer) {
        console.warn(`[main-collection-2-filter-drawer-toggle] Drawer not found: ${targetId}`);
        return;
      };
      
      if (this.drawer?.classList.contains("main-collection2-filter-drawer--loading")) {
        this.drawer.classList.remove("main-collection2-filter-drawer--loading");
      }

      this.panel = document.getElementById('MainCollection2FilterDrawerPanel');
      this.overlay = document.getElementById('MainCollection2FilterDrawerOverlay');

      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      this.setAttribute('aria-expanded', 'false');

      this.addEventListener('click', this.onClickHandler);
      document.addEventListener("main-collection-2:filter-drawer:open", this.openDrawer);
      this.addEventListener('keydown', this.onKeyDownHandler);

      if (this.overlay){
        this.overlay.addEventListener("click", this.onOverlayClickHandler)
      }
      
      document.addEventListener('keydown', this.onDocumentKeydownHandler);

    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClickHandler);
      this.removeEventListener('keydown', this.onKeyDownHandler);
      
      if (this.overlay) {
        this.overlay.removeEventListener('click', this.onOverlayClickHandler);
      }
      
      document.removeEventListener('keydown', this.onDocumentKeydownHandler);
      document.removeEventListener("main-collection-2:filter-drawer:open", this.openDrawer);
    }

    onClickHandler() {
      this.toggleDrawer();
    }

    toggleDrawer() {
      if (this.isOpen()) {
        this.closeDrawer();
      } else {
        this.openDrawer();
      }
    }

    isOpen() {
      return this.drawer.dataset.state === 'open';
    }

    openDrawer() {
      if (!this.drawer || !this.panel) return;

      this.drawer.dataset.state = 'open';

      this.drawer.classList.remove('tw-pointer-events-none');

      this.overlay?.classList.remove('tw-opacity-0');
      
      this.panel.classList.remove('xl:tw--translate-x-full');
      this.panel.classList.remove('bxl:tw-translate-y-full');

      this.setAttribute('aria-expanded', 'true');

      this.drawer.setAttribute('aria-hidden', 'false');

      document.body.style.overflow = "hidden";

      this.dispatchEvent(
        new CustomEvent('main-collection-2:filter-drawer-open', {
          bubbles: true
        })
      );
    }

    closeDrawer() {

      if (!this.drawer || !this.panel) return;

      this.drawer.dataset.state = 'closed';

      this.overlay?.classList.add('tw-opacity-0');

      this.panel.classList.add('bxl:tw-translate-y-full');
      this.panel.classList.add('xl:tw--translate-x-full');

      this.setAttribute('aria-expanded', 'false');

      this.drawer.setAttribute('aria-hidden', 'true');

      document.body.style.overflow = "auto";

      setTimeout(() => {
        if (this.drawer.dataset.state === 'closed') {
          this.drawer.classList.add('tw-pointer-events-none');
        }
      }, 300);


      this.dispatchEvent(
        new CustomEvent('main-collection-2:filter-drawer-close', {
          bubbles: true
        })
      );
    }

    onOverlayClickHandler() {
      this.closeDrawer();
    }

    onKeyDownHandler(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggleDrawer();
      }
    }

    onDocumentKeydownHandler(event) {
      if (event.key === 'Escape') {
        this.closeDrawer();
      }
    }
  }
  customElements.define('main-collection-2-filter-drawer-toggle', MainCollection2FilterDrawerToggle);
}